import request from '@/utils/request';

/**
 * 新增
 * @param
 */
export function addRole(pram) {
  var data = {
    roleName: pram.roleName,
    status: pram.status,
    rules: pram.rules
  };
  // data.rules = pram.rules.join(',')
  return request({
    url: '/admin/distribution/role/save',
    method: 'POST',
    data: data
  });
}

/**
 * 删除
 * @param
 */
export function delRole(id) {
  return request({
    url: "/admin/distribution/role/delete/".concat(id),
    method: 'post'
  });
}

/**
 * 详情
 * @param
 */
export function getInfo(pram) {
  return request({
    url: "/admin/distribution/role/info/".concat(pram),
    method: 'GET'
  });
}

/**
 * 分页列表
 * @param
 */
export function getRoleList(pram) {
  var data = {
    page: pram.page,
    limit: pram.limit,
    roleName: pram.roleName,
    status: pram.status
  };
  return request({
    url: '/admin/distribution/role/list',
    method: 'get',
    params: data
  });
}

// 淘客角色接口使用 type=10 菜单和 distribution 权限，与商户角色完全分离。
export function distributionRoleList(pram) {
  return request({
    url: '/admin/distribution/role/list',
    method: 'GET',
    params: {
      page: pram.page,
      limit: pram.limit,
      roleName: pram.roleName,
      status: pram.status,
      roleType: 10
    }
  });
}
export function distributionRoleAdd(pram) {
  return request({
    url: '/admin/distribution/role/save',
    method: 'POST',
    data: {
      roleName: pram.roleName,
      status: pram.status,
      rules: pram.rules,
      roleType: 10
    }
  });
}
export function distributionRoleDelete(id) {
  return request({
    url: '/admin/distribution/role/delete/' + id,
    method: 'POST'
  });
}
export function distributionRoleInfo(id) {
  return request({
    url: '/admin/distribution/role/info/' + id,
    method: 'GET'
  });
}
export function distributionRoleUpdate(pram) {
  return request({
    url: '/admin/distribution/role/update',
    method: 'POST',
    data: {
      id: pram.id,
      roleName: pram.roleName,
      rules: pram.rules,
      status: pram.status,
      roleType: 10
    }
  });
}
export function distributionRoleUpdateStatus(pram) {
  return request({
    url: '/admin/distribution/role/updateStatus',
    method: 'POST',
    data: {
      id: pram.id,
      status: pram.status
    }
  });
}
export function distributionRoleMenuCacheList() {
  return request({
    url: '/admin/distribution/role/menu/cache/tree',
    method: 'GET'
  });
}

/**
 * 修改
 * @param
 */
export function updateRole(pram) {
  var data = {
    id: pram.id,
    roleName: pram.roleName,
    rules: pram.rules,
    status: pram.status
  };
  return request({
    url: '/admin/distribution/role/update',
    method: 'post',
    data: data
  });
}

/**
 * 修改身份状态
 * @param
 */
export function updateRoleStatus(pram) {
  return request({
    url: '/admin/distribution/role/updateStatus',
    method: 'post',
    data: {
      id: pram.id,
      status: pram.status
    }
  });
}

/**
 * 缓存菜单
 * @param
 */
export function menuCacheList(pram) {
  return request({
    url: '/admin/distribution/role/menu/cache/tree',
    method: 'get'
  });
}